import { render, staticRenderFns } from "./YandexMapsPage.vue?vue&type=template&id=67e5f2be&"
import script from "./YandexMapsPage.vue?vue&type=script&lang=js&"
export * from "./YandexMapsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports